module.exports = __webpack_public_path__ + "static/media/comment6_1.f82bcf14.png";